import script from "./LocationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocationModal.vue?vue&type=script&setup=true&lang=ts"

import "./LocationModal.vue?vue&type=style&index=0&id=27d0740d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d0740d"]])

export default __exports__